import React from 'react';
import { connect } from 'react-redux';

class Referral extends React.Component<any> {

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_REFERRAL',
			payload: this.props.match.params.code
		});

		this.props.history.replace('/');
	}

	render() {
		return null;
	}
}

export default connect()(Referral);